import { type ElementType, type ItemDetails, type LegacySegmentTypes, Track } from '@1debit/analytics';
import { type MouseEvent, useCallback } from 'react';

import { useAnalytics } from './useAnalytics';

import { type AnalyticsId } from '../AnalyticsProvider';

export function useClickableElementAnalytics(
	analyticsId: AnalyticsId,
	type: LegacySegmentTypes.ElementType,
	itemDetails: ItemDetails | undefined,
	itemValue: string | undefined,
) {
	const analytics = useAnalytics();
	const handleClick = useCallback(
		<T>(onClick?: (event: MouseEvent<T>) => void) => {
			return (event: MouseEvent<T>) => {
				if (analytics && analyticsId) {
					analytics.handler.trackElementClicked({
						unique_id: analyticsId,
						type: type,
						location: analytics.location,
					});
					analytics.handler.trackEvent(Track.WebItemClicked, {
						unique_id: analyticsId,
						// [Temporary until we finish event migration] We are casting here because we know that the types are the same
						element_type: type as unknown as ElementType,
						item_details: itemDetails,
						item_value: itemValue,
					});
				}

				if (onClick) {
					onClick(event);
				}
			};
		},
		[analytics, analyticsId, type, itemDetails, itemValue],
	);

	return {
		handleClick,
	};
}
